import {makeAutoObservable} from 'mobx';
import * as Api from '@/utils/api/api';

class RecommendListStore {
  list = [];
  pageSize = 6;
  pageNum = 1;

  constructor() {
    makeAutoObservable(this)
  }

   async fetchList() {
    try {
      const { pageSize, pageNum } = this;

      const { list } = await Api.recommendList({ pageSize, pageNum });

      this.list = list;
    } catch (error) {}
  }
}

export default RecommendListStore;
